/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'cardboard box<br/>felt paper<br/>paper towel tube<br/>hot glue<br/>scissors<br/>bubble wrap<br/>4 thin dowels (size depends on width of cardboard box)<br/>Monster Jam truck',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urt',
    },
    {
      stepDescription:
        'Cut felt strips about 1½” wide each. Be sure to keep strips attached at the top, leaving about 2” of felt in tact. Next, cut smaller strips for the car wash rollers. Hot glue the felt onto the paper towel tube',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsd',
    },
    {
      stepDescription:
        'Parents, cut out the car wash door flap. Cut holes in sides at equal heights and slide in the dowels.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYA',
    },
    {
      stepDescription:
        'Parents, hot glue the curtains to the dowels and onto the top of the exit door',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYz',
    },
    {
      stepDescription:
        'Give your car wash a name and you’re ready for customers!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xse',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
